import React from "react";
import { IoMdPhonePortrait } from "react-icons/io";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css'; 
import bg from '../../../assets/DublinPage/Best_Roofing_Contractor_in_Dublin_Ohio-Ultimatesroofing.jpg';

import ContactModal from '../../HomePage/ContactModal';
import { Button } from "react-bootstrap";
import { LiaRibbonSolid } from "react-icons/lia";
import './Main.css';

const Hero = () => {
  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top 60%',
    width: '100%',
    display: 'flex',
    color: 'white',
  };

  return (
    <div style={heroStyle} className="hero-container">
      <div className="container d-flex flex-column align-items-center justify-content-center">
        <div className="row w-100 justify-content-center">
          <div className="col-lg-11 animate__animated animate__fadeInUp d-flex flex-column align-items-center text-center">
            
            {/* Optimized Heading */}
            <h1 className="main_heading">
              Your Trusted Roofing Contractor in Dublin, Ohio
            </h1>

            <p className="mb-lg-4 roofing_text mx-auto">
            Serving Dublin, Ohio Areas
We are a BBB A+ rated roofing company serving homeowners and businesses across Dublin, Ohio. Ultimates Roofing provides trusted roofing solutions you can trust. Whether it’s a small repair, a full roof replacement, or a commercial roofing project, our roofing team delivers high-quality workmanship backed by decades of experience.

            </p>

            <p className="mb-lg-5 roofing_text mx-auto">
              From free inspections to emergency roof repairs, we ensure your property remains protected and your investment secure. With more than 20+ years of combined experience.
            </p>

            {/* Badges Section */}
            <div className="badge-wrapper d-flex flex-wrap justify-content-center gap-3 my-3">
              <div className="badge-custom animate__animated animate__fadeInLeft animate__delay-1s">
                <i className="bi bi-geo-alt text-danger me-2"></i>
                <span>Dublin, OH</span>
              </div>

              <div className="badge-custom animate__animated animate__fadeInLeft animate__delay-2s">
                <i className="bi bi-shield-check text-danger me-2"></i>
                <span>Licensed Bonded & Insured</span>
              </div>

              <div className="badge-custom animate__animated animate__fadeInLeft animate__delay-3s">
                <LiaRibbonSolid className="text-danger me-1 fs-5" />
                <span>20+ Years Experience</span>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="btn-group-custom d-flex flex-wrap gap-3 align-items-center justify-content-center">
              <Button className="phonebtn px-1">
                <div className="d-flex gap-2 align-items-center justify-content-center">
                  <IoMdPhonePortrait className="fs-5" />
                  <a href="tel:+16143577539" className="text-decoration-none text-white">
                    +1 614-357-7539
                  </a>
                </div>
              </Button>
              <div className="modal-trigger-wrapper">
                 <ContactModal />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
